import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core"
import { FormBuilder, FormGroup } from "@angular/forms"
import { IconImageService } from "@shared/services/icon-image.service"
import { LabelValue } from "../ag-drop-down.component"

@Component({
  selector: "ag-single-description-box",
  templateUrl: "./ag-single-description-box.component.html",
  styleUrls: ["./ag-single-description-box.component.scss"],
  standalone: false,
})
export class AgSingleDescriptionBoxComponent implements OnInit {
  @Input() list: LabelValue[] = []
  @Input() disabledInputs: LabelValue[] = []
  @Input() showBox = false
  @Input() showSearchField = true
  @Input() useFixedPosition = false
  @Input() maxHeight: number = 800
  @Input() currentValue: LabelValue
  @Input() withHoverEffect: boolean = false

  @Output() output = new EventEmitter<LabelValue>()
  @Output() searchBoxFieldClicked = new EventEmitter<boolean>()

  @ViewChild("inputField", { static: false }) inputField: ElementRef

  public displayedList: LabelValue[] = []
  public searchForm: FormGroup
  public isTyping = false

  constructor(
    private fb: FormBuilder,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchInput: [""],
    })
    this.displayedList = this.list
  }

  onInputChange(value: string): void {
    if (value === "") {
      this.isTyping = false
      this.displayedList = this.list
    } else {
      this.isTyping = true
      this.displayedList = this.list.filter((x) => x.label.toLowerCase().includes(value.toLowerCase()))
    }
  }

  showBoxClicked(): boolean {
    if (!this.isTyping || (this.inputField && this.inputField.nativeElement && this.inputField.nativeElement.value === "")) {
      this.displayedList = this.list
    }
    return true
  }

  onItemClicked(item: LabelValue): void {
    if (item.label !== this.currentValue?.label) {
      this.currentValue = item
      this.output.emit(item)
      this.showBox = false
    }
  }

  checkSelectedItems(item: LabelValue): boolean {
    return this.currentValue?.label === item?.label
  }

  trackByFn(index: number, item: LabelValue): any {
    return item.value
  }
}
